/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-04 11:19:00
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-08 10:12:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/ReadyToCollect/index.tsx
 */
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { notifyCustomer, printPackingSlip } from 'src/request/order';
import { msg } from 'src/tools/message';
//import css from './css.module.less';
import Category from '../Components/Category';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ReadyToShip = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { data, orderNo, onUpdate, onUndo, disabled, disablePrint } = props;
  return (
    <Category
      title={getI18n(
        `allOrders.orderDetail.readytocollect_return_category_title`,
      )}
      data={data.map((i) => {
        const image = get(i, 'images.0.url');
        const pickedDate = get(i, 'pickedDate', null);
        const packedDate = get(i, 'packedDate', null);
        const pickDate = moment(pickedDate).format('YYYY-MM-DD hh:mm');
        const packDate = moment(packedDate).format('YYYY-MM-DD hh:mm');
        const parcelNo = get(i, 'parcelNo');
        const uuid = get(i, 'uuid');
        return {
          uuid,
          image,
          sku: `${orderNo}-${parcelNo}`,
          options: [
            {
              title: getI18n(
                `allOrders.orderDetail.readytocollect_returndata_options_pickedtitle`,
              ),
              content: pickDate || '-',
            },
            { title: '', content: '' },
            {
              title: getI18n(
                `allOrders.orderDetail.readytocollect_returndata_options_packedtitle`,
              ),
              content: packDate,
            },
          ],
          btns: [
            {
              text: getI18n(
                `allOrders.orderDetail.readytocollect_returndata_Notifybtns_text`,
              ),
              disabled: disabled,
              onClick: () => {
                notifyCustomer(uuid, i).then((res) => {
                  onUpdate(res);
                  msg.success(
                    getI18n(
                      `allOrders.orderDetail.readytocollect_returndata_Notifybtns_msgsuccess`,
                    ),
                  );
                });
              },
            },
            {
              text: getI18n(
                `allOrders.orderDetail.readytocollect_returndata_printbtns_text`,
              ),
              disabled: disablePrint,
              onClick: () => printPackingSlip(uuid),
            },
          ],
          ...(!disabled && {
            dropOptions: [
              {
                label: getI18n(
                  `allOrders.orderDetail.readytocollect_returndata_dropoptions_label`,
                ),
                onClick: () => {
                  onUndo(uuid, (res) => {
                    onUpdate(res);
                    msg.success(
                      getI18n(
                        `allOrders.orderDetail.readytocollect_returndata_dropoptions_msgsuccess`,
                      ),
                    );
                    //    console.log('undo', res);
                  });
                },
              },
            ],
          }),
        };
      })}
    />
  );
};
export default ReadyToShip;
